import { type RecordId } from '../shared-types';

export const extractWhiteboardId = (url: string): RecordId => {
  const pathParts = url.split(/\?|#/)[0].replace(/\/+$/, '').split('/');
  return pathParts[pathParts.length - 1] as RecordId;
};
